import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import data from './data';
import * as firebase from "firebase/app"
import "firebase/analytics";

Vue.config.productionTip = false;

const firebaseConfig = {
  apiKey: 'AIzaSyBcw0tV6NaNfVv0mewX8dzYrOXRxj2Ryxg',
  authDomain: 'auszeit-79f94.firebaseapp.com',
  databaseURL: 'https://auszeit-79f94.firebaseio.com',
  projectId: 'auszeit-79f94',
  storageBucket: 'auszeit-79f94.appspot.com',
  messagingSenderId: '293132385055',
  appId: '1:293132385055:web:b8148917d1b08fc5bdce2a',
  measurementId: 'G-810T740XJ4'
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();


Vue.mixin({
  methods: {
    getTourList() {
      return data;
    }
  }
});

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app');
